import IUserData from '../../../types/sign-in/IUserData'

export const sessionManagerState = {
  currentUser: null as IUserData,
  isLoadingCurrentUser: false,
  isMounted: false,
  callbackUrl: false
}

export type SessionManagerState = typeof sessionManagerState
